/**
 * gallery.js — wirtschaft. am markt
 * ---------------------------------------------------------------------------
 * Motion for the "Markt Stories." collage (see gallery.css):
 *   - Reveal: items fade/rise in the first time they enter the viewport
 *     (IntersectionObserver toggles .is-inview; the hidden initial state is
 *     gated behind .gallery--ready so no-JS visitors see everything).
 *   - Parallax: while the section is on screen, each collage position
 *     drifts at its own speed relative to the viewport center. Runs inside
 *     one rAF loop that only ticks while the section is visible, so it
 *     plays nicely with the Lenis smooth scroll.
 * Both effects are skipped for prefers-reduced-motion and when the section
 * has data-gallery-static (theme setting).
 */

(() => {
  "use strict";

  // Drift factors per collage position (cycle of five, see gallery.css).
  var SPEEDS = [0.05, -0.065, 0.045, -0.05, 0.07];

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function initGallery(root) {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = "true";

    if (reducedMotion.matches) return;

    var items = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-item]"));
    if (!items.length) return;

    /* ---- Reveal ----------------------------------------------------------- */
    root.classList.add("gallery--ready");

    var reveal = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-inview");
            reveal.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    items.forEach(function (item) {
      reveal.observe(item);
    });

    /* ---- Parallax --------------------------------------------------------- */
    if (root.hasAttribute("data-gallery-static")) return;

    var motions = items
      .map(function (item, index) {
        var el = item.querySelector("[data-gallery-motion]");
        return el ? { el: el, speed: SPEEDS[index % SPEEDS.length] } : null;
      })
      .filter(Boolean);

    var rafId = null;

    function tick() {
      var vpCenter = window.innerHeight / 2;
      motions.forEach(function (m) {
        var rect = m.el.getBoundingClientRect();
        var offset = (rect.top + rect.height / 2 - vpCenter) * m.speed;
        m.el.style.transform = "translate3d(0, " + offset.toFixed(1) + "px, 0)";
      });
      rafId = requestAnimationFrame(tick);
    }

    var gate = new IntersectionObserver(function (entries) {
      var visible = entries.some(function (entry) {
        return entry.isIntersecting;
      });
      if (visible && rafId === null) {
        rafId = requestAnimationFrame(tick);
      } else if (!visible && rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    });
    gate.observe(root);
  }

  function initAll(scope) {
    scope.querySelectorAll("[data-gallery]").forEach(initGallery);
  }

  initAll(document);

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
